module.exports = __webpack_public_path__ + "static/img/learner-management.72e014a5.png";